/* unplugin-vue-components disabled */import { render } from "./ClassRoomAnswerDetailView.vue?vue&type=template&id=06e43723&scoped=true"
import script from "./ClassRoomAnswerDetailView.vue?vue&type=script&lang=js"
export * from "./ClassRoomAnswerDetailView.vue?vue&type=script&lang=js"

import "./ClassRoomAnswerDetailView.vue?vue&type=style&index=0&id=06e43723&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e43723"]])

export default __exports__